import { render, staticRenderFns } from "./FacilityAreaAndLocation.vue?vue&type=template&id=d10b3ffe&scoped=true"
import script from "./FacilityAreaAndLocation.vue?vue&type=script&lang=js"
export * from "./FacilityAreaAndLocation.vue?vue&type=script&lang=js"
import style0 from "./FacilityAreaAndLocation.vue?vue&type=style&index=0&id=d10b3ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10b3ffe",
  null
  
)

export default component.exports